import { useAnalytics as usePackageAnalytics } from '@3plearning/mx-teacher-analytics/react';

// The package hook throws without an <AnalyticsProvider>. Tests render
// components in isolation, so fall back to null (a no-op client) there.
const useAnalyticsClient = () => {
  try {
    return usePackageAnalytics();
  } catch (error) {
    return null;
  }
};

export default useAnalyticsClient;
